import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaArrowRight } from 'react-icons/fa';
import { cloudinaryAsset } from '../config/media';

const About = () => {
  const { t } = useTranslation();

  return (
    <div id="about">
      {/* Hero Section */}
      <section className="about-hero py-5 text-white" style={{
        background: 'linear-gradient(135deg, rgba(30, 80, 150, 0.9) 0%, rgba(22, 61, 115, 0.9) 100%), url("/stand-phibro.png") center/cover no-repeat'
      }}>
        <Container>
          <Row className="align-items-center">
            <Col lg={8} className="mx-auto text-center">
              <h1 className="display-4 fw-bold mb-4">{t('about.title')}</h1>
              <p className="fs-5 mb-4">
                {t('about.subtitle')}
              </p>
              <Button variant="outline-light" size="lg">
                {t('about.downloadCatalog')}
              </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Quiénes Somos */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h2 className="mb-4">{t('about.whoWeAre')}</h2>
              <p className="fs-5 mb-3">
                {t('about.whoWeAreDescription')}
              </p>
              <p className="text-muted">
                {t('about.whoWeAreDetails')}
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Misión y Visión */}
      <section id="about-details" className="py-5" style={{ background: '#f8f9fa' }}>
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <h3 className="mb-3" style={{ color: '#1E5096' }}>{t('about.mission')}</h3>
                  <p className="text-muted">
                    {t('about.missionDescription')}
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6} className="mb-4">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <h3 className="mb-3" style={{ color: '#1E5096' }}>{t('about.vision')}</h3>
                  <p className="text-muted mb-3">
                    {t('about.visionDescription')}
                  </p>
                  <p className="text-muted">
                    {t('about.visionDetails')}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Machinery Section */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10} className="text-center">
              <h2 className="mb-4" style={{ color: '#1E5096' }}>{t('about.machineryTitle')}</h2>
              <ul className="list-unstyled row">
                {t('about.machineryList', { returnObjects: true }).map((item, index) => (
                  <Col md={6} lg={4} key={index} className="mb-3">
                    <Card className="h-100 border-0 shadow-sm p-3">
                      <p className="mb-0 fw-bold text-muted">{item}</p>
                    </Card>
                  </Col>
                ))}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="about-feature">
        <div className="about-feature-grid">
          <img
            src={cloudinaryAsset('/home/1.5 Sobre nosotros/Sobre nosotros.jpg')}
            alt={t('homeRedesign.about.imageAlt')}
            loading="lazy"
          />
          <div className="about-feature-copy">
            <p className="about-feature-eyebrow">Exhibirte</p>
            <h2>{t('homeRedesign.about.title')}</h2>
            <h3>{t('homeRedesign.about.subtitle')}</h3>
            <p>{t('homeRedesign.about.paragraph1')}</p>
            <p>{t('homeRedesign.about.paragraph2')}</p>
            <a href="#about" className="about-feature-link">
              {t('homeRedesign.about.link')} <FaArrowRight aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>
    </div >
  );
};

export default About;
